import { dataLocal } from '../../utils/dataLocal';
import { sanitizeChatMessage } from '../../utils/safeHtml';
import { chatAttachmentUrlFromMessage } from '../../utils/chatAttachment';
import React, { forwardRef, useCallback, useContext, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getHistoryRooms } from '../../redux/room/room.actions';
import {
  ehSoMeuHistorico,
  nomesDosOperadores,
  selecaoDeOperadores,
} from '../../utils/selecaoDeOperadores';
import './history.css'
import { Autocomplete, Box, Button, CardMedia, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, ListItemText, MenuItem, Paper, Rating, Select, TextField, Tooltip, Typography } from '@mui/material';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TableInfo from '../../components/TableInfo';
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns';
import { CloseSharp, SearchSharp, ZoomIn } from '@material-ui/icons';
// Os ícones DESTE arquivo vêm de dois pacotes: `@material-ui/icons` é o v4 e
// ignora `sx` (o motor de estilo é outro). Os dois adornos de campo abaixo
// usam o v5.
import { FilterAltOffSharp, FilterAltSharp, ChatBubbleOutlineOutlined, CalendarTodayOutlined, SearchOutlined } from '@mui/icons-material';
import FilePreview from '../../components/FilePreview';
import FilterSlidePanel from '../../components/FilterSlidePanel';
import { CANAIS, CANAL_TODOS } from '../../utils/canalDaConversa';
import {
  departamentosDoHistorico,
  filtrarHistorico,
  linhasDoHistorico,
  LINHA_TODAS,
  rotulosDasAvaliacoes,
  rotulosDosDepartamentos,
} from '../../utils/filtrosDoHistorico';
import ResumoDoHistorico from '../../components/ResumoDoHistorico';

const HistoryPage = props => {
  const history = useHistory();
  const [rows, setRows] = useState([])
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const { theme } = useContext(ThemeContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filterType, setFilterType] = useState("message"); // Default será "message"
  const user = JSON.parse(localStorage.getItem('user'));
  const { permissions } = props;
  /*
   * MAIS DE UM OPERADOR (Gisele, 28/10/2026, bloco do Histórico).
   *
   * Era um id só. Virou lista, e o padrão continua sendo "o meu histórico" --
   * a lista com o meu id. Lista VAZIA não existe aqui: a api a trata como "o
   * meu", e deixar a tela chegar nesse estado faria o seletor em branco
   * mostrar o histórico de alguém sem dizer de quem.
   */
  const [selectedUserIds, setSelectedUserIds] = useState([user.id]);

  /** Só o meu histórico, que é o estado inicial e o "sem filtro de operador". */
  const soMeuHistorico = ehSoMeuHistorico(selectedUserIds, user.id);

  /** Os operadores escolhidos, por NOME -- id cru não diz nada a ninguém. */
  const operadoresEscolhidos = () => nomesDosOperadores(selectedUserIds, user.id, props.users);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [periodType, setPeriodType] = useState('custom');
  const [clientSearchValue, setClientSearchValue] = useState('');
  /*
   * Avaliação e departamento, os dois com MÚLTIPLA seleção (pedido da
   * Gisele, bloco do Histórico). Lista vazia é "sem filtro" -- era o que o
   * valor `all` do seletor único significava.
   */
  const [evaluationFilters, setEvaluationFilters] = useState([]);
  const [departamentoFilters, setDepartamentoFilters] = useState([]);
  // Canal e produto: duas perguntas diferentes, por isso dois estados
  // (ponto 13 da Gisele). Ver `utils/filtrosDoHistorico`.
  const [canalFilter, setCanalFilter] = useState(CANAL_TODOS);
  const [linhaFilter, setLinhaFilter] = useState(LINHA_TODAS);
  // As linhas que EXISTEM no período carregado. Oferecer uma linha sem
  // nenhuma conversa só daria um filtro que devolve vazio.
  const linhasDisponiveis = useMemo(
    () => linhasDoHistorico(props.historyRooms),
    [props.historyRooms]
  );
  // Mesma regra para os departamentos, e por isso saem do mesmo lugar.
  const departamentosDisponiveis = useMemo(
    () => departamentosDoHistorico(props.historyRooms),
    [props.historyRooms]
  );

  /*
   * Algum filtro está recortando a lista?
   *
   * Uma vez, e não três. Esta condição estava copiada em três lugares -- o
   * ícone do botão, a marcação do painel e o bloco de "Filtros Ativos" -- e
   * nas três cópias faltavam canal e produto: com um deles marcado o botão
   * mostrava o ícone de "sem filtro" e o resumo não aparecia.
   */
  const temFiltroAtivo = !soMeuHistorico
    || periodType !== 'custom'
    || clientSearchValue !== ''
    || evaluationFilters.length > 0
    || departamentoFilters.length > 0
    || canalFilter !== CANAL_TODOS
    || linhaFilter !== LINHA_TODAS;
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);

  const handleClickOpen = (imageUrl) => {
    setSelectedImage(imageUrl); // Define a URL da imagem que foi clicada
    setOpen(true); // Abre o modal
    console.log(selectedImage)
  };

  const handleClose = () => {
    setOpen(false); // Fecha o modal
    setSelectedImage(''); // Reseta a imagem selecionada
  };

  const handleDateChange = useCallback((start, end, dateType) => {
    if (dateType) {
      setStartDate(new Date());
      setEndDate(new Date());
      props.getHistoryRooms(dateType, selectedUserIds);
    } else {
      setStartDate(start);
      setEndDate(end);
      const startDateStr = formatDate(start);
      const endDateStr = formatDate(end);
      const dateStr = startDateStr + ':' + endDateStr;
      props.getHistoryRooms(dateStr, selectedUserIds);
    }
  }, [props, selectedUserIds]);

  const handlePeriodChange = (period) => {
    setPeriodType(period);
    const today = new Date();
    
    switch (period) {
      case 'today':
        setStartDate(today);
        setEndDate(today);
        props.getHistoryRooms(formatDate(today) + ':' + formatDate(today), selectedUserIds);
        break;
      case 'week':
        const weekAgo = new Date(today);
        weekAgo.setDate(today.getDate() - 7);
        setStartDate(weekAgo);
        setEndDate(today);
        props.getHistoryRooms(formatDate(weekAgo) + ':' + formatDate(today), selectedUserIds);
        break;
      case 'month':
        const monthAgo = new Date(today);
        monthAgo.setMonth(today.getMonth() - 1);
        setStartDate(monthAgo);
        setEndDate(today);
        props.getHistoryRooms(formatDate(monthAgo) + ':' + formatDate(today), selectedUserIds);
        break;
      case 'custom':
        // Mantém as datas atuais
        break;
      default:
        break;
    }
  };

  const handleOpenFilterPanel = () => setFilterPanelOpen(true);
  const handleCloseFilterPanel = () => setFilterPanelOpen(false);

  const handleApplyFilters = () => {
    // Aplicar os filtros atuais
    handleDateChange(startDate, endDate, null);
    setFilterPanelOpen(false);
  };

  const handleClearFilters = () => {
    setPeriodType('custom');
    setStartDate(new Date());
    setEndDate(new Date());
    setClientSearchValue('');
    setEvaluationFilters([]);
    setDepartamentoFilters([]);
    // Canal e produto também: "Limpar filtros" que deixa dois marcados é
    // pior que não ter o botão.
    setCanalFilter(CANAL_TODOS);
    setLinhaFilter(LINHA_TODAS);
    // Recarregar dados sem filtros
    setSelectedUserIds([user.id]);
    props.getHistoryRooms('today', [user.id]);
  };

  // Delegado a `dataLocal`: era `toISOString()`, que converte para UTC antes
  // de cortar. Das 21h em diante, no Brasil, o "hoje" do filtro virava o dia
  // seguinte e a tela dizia "Nenhum dado encontrado" -- sem erro, sem pista.
  function formatDate(date) {
    return dataLocal(date);
  }

  const formatTime = (duration) => {
    const parts = duration.split(":").map(Number);

    if (parts.length !== 3) {
      return duration;
    }

    let [hours, minutes, seconds] = parts;

    let totalSeconds = hours * 3600 + minutes * 60 + seconds;

    const days = Math.floor(totalSeconds / (24 * 3600));
    totalSeconds %= 24 * 3600;

    hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;

    minutes = Math.floor(totalSeconds / 60);
    totalSeconds %= 60;

    seconds = totalSeconds;

    const partsText = [];
    if (days > 0) {
      partsText.push(`${days === 1 ? `${days} dia` : `${days} dias`}`);
    }
    if (hours > 0) {
      partsText.push(`${hours === 1 ? `${hours} hora` : `${hours} horas`}`);
    }
    if (minutes > 0) {
      partsText.push(`${minutes === 1 ? `${minutes} minuto` : `${minutes} minutos`}`);
    }
    if (seconds > 0) {
      partsText.push(`${seconds === 1 ? `${seconds} segundo` : `${seconds} segundos`}`);
    }

    return partsText.join(" e ");
  };


  const createRows = useCallback(() => {
    // Os recortes do conjunto -- canal, produto, avaliação e departamento --
    // vêm todos de `filtrarHistorico`, e a busca por cliente abaixo refina o
    // que sobrou.
    let filteredRooms = filtrarHistorico(props.historyRooms, {
      canal: canalFilter,
      linha: linhaFilter,
      avaliacoes: evaluationFilters,
      departamentos: departamentoFilters,
    });


    /*
     * Filtrar por cliente se houver pesquisa.
     *
     * Partia de `props.historyRooms`, e não da lista já recortada. Ou seja:
     * digitar um nome aqui DESFAZIA em silêncio os filtros de canal e de
     * produto -- a tela continuava mostrando os dois marcados no painel e
     * listava conversas dos outros canais.
     */
    if (clientSearchValue.trim()) {
      filteredRooms = filteredRooms.filter(room => {
        const clientName = room.client.name ? room.client.name.toLowerCase() : '';
        const clientCode = room.client.company && room.client.company.code ?
          String(room.client.company.code).toLowerCase() : '';
        const businessName = room.client.company && room.client.company.business_name ?
          room.client.company.business_name.toLowerCase() : '';
        const searchTerm = clientSearchValue.toLowerCase();

        return clientName.includes(searchTerm) ||
                       clientCode.includes(searchTerm) ||
                       businessName.includes(searchTerm);
      });
    }

    const newRows = filteredRooms.map((room, id) => {
      const durationParts = room.service_time.split(':').map(Number);
      const roomDurationMilliseconds =
        durationParts[0] * 60 * 60 * 1000 + // hours to milliseconds
        durationParts[1] * 60 * 1000 +      // minutes to milliseconds
        durationParts[2] * 1000;            // seconds to milliseconds

      return {
        id: room.room_id,
        evaluation: room.evaluation,
        evaluationComment: room.evaluation_comment,
        clientName: room.client.name,
        clientEmail: room.client.email,
        operatorName: room.user.name,
        businessName: room.client.company ? room.client.company.business_name : null,
        roomEvaluation: room.evaluation,
        clientCode: room.client.company ? room.client.company.code : "Sem registro",
        messages: room.messages,
        roomDuration: room.service_time === "00:00:00"
          ? "---"
          : formatTime(room.service_time),
        roomDurationMilliseconds,
        date: room.created_at
          ? dateFormat(room.created_at)
          : `${new Date().getHours()}:${new Date().getMinutes()}`,
        endDate: room.updated_at
          ? dateFormat(room.updated_at)
          : `${new Date().getHours()}:${new Date().getMinutes()}`,
        ticketId: room.movidesk_ticket_id,
      };
    });

    setRows(newRows);
  }, [props.historyRooms, clientSearchValue, evaluationFilters, departamentoFilters, canalFilter, linhaFilter]);


  useEffect(() => {
    /*
     * A lista NUNCA fica vazia (o seletor não deixa desmarcar o último), e
     * por isso o ramo de "sem operador" saiu: ele chamava
     * `getHistoryRooms()` sem data nem operador, o que a api lê como "hoje, o
     * meu" -- outra coisa do que a tela estava mostrando.
     */
    handleDateChange(startDate, endDate, null);
    // eslint-disable-next-line
  }, [selectedUserIds]);

  useEffect(() => {
    createRows()
    // eslint-disable-next-line
  }, [props.historyRooms, clientSearchValue, evaluationFilters, departamentoFilters, canalFilter, linhaFilter])

  const dateFormat = date => {
    const result = new Date(date).toLocaleString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });

    let parts = result.split(",");
    parts[1] = parts[1] + 'h';
    return parts.join(",");
  }

  const columns = [
    {
      field: 'ticketId',
      headerName: 'Protocolo',
      editable: false,
      description: 'Protocolo do Ticket no Movidesk',
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <Grid sx={{ backgroundColor: "transparent" }}
            container direction="column" alignItems="center" justifyContent="center" wrap='nowrap'>
            <Tooltip title={params.row.ticketId}>
              <IconButton
                onClick={() => history.push(`/ticket/${params.row.ticketId}`)}
                sx={{
                  bgcolor: 'transparent', color: theme.palette.text.secondary,
                  '&:hover': { bgcolor: 'transparent' },
                  fontSize: '14px'
                }}
              >
                <Typography variant="body2" color="textSecondary" flexWrap={'nowrap'}
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                  }}>
                  {params.row.ticketId}
                </Typography>
              </IconButton>
            </Tooltip>

          </Grid>
        );
      },
    },
    {
      field: 'clientCode',
      headerName: 'Cliente',
      editable: false,
      description: 'Registro, Nome da Loja e Dados do Cliente',
      flex: 2,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const businessName = params.row.businessName || '';
        const clientName = params.row.clientName || '';

        return (
          <Grid style={{
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '8px 0',
            backgroundColor: 'transparent'
          }}>
            <Grid style={{ 
              color: theme.palette.text.primary, 
              backgroundColor: 'transparent',
              fontSize: 16, 
              fontWeight: 700,
              marginBottom: '4px',
              lineHeight: 1.2
            }}>
              {params.row.clientCode}
            </Grid>
            {businessName && (
              <Grid style={{ 
                color: theme.palette.text.secondary, 
                backgroundColor: 'transparent',
                fontSize: 11, 
                fontWeight: 400,
                marginBottom: '2px',
                opacity: 0.7,
                lineHeight: 1.1
              }}>
                {businessName}
              </Grid>
            )}
            <Grid style={{ 
              color: theme.palette.text.primary, 
              backgroundColor: 'transparent',
              fontSize: 14, 
              fontWeight: 600,
              lineHeight: 1.2
            }}>
              {clientName}
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: 'evaluation',
      headerName: 'Avaliação',
      editable: false,
      description: 'Nota de atendimento',
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Rating name="size-small"
            defaultValue={params.row.evaluation} size="small" max={3}
            readOnly
          />
          {params.row.evaluationComment && (
            <Tooltip title={params.row.evaluationComment} arrow>
              <ChatBubbleOutlineOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help' }} />
            </Tooltip>
          )}
        </Box>
      ),
    },
    {
      field: 'operatorName',
      headerName: 'Operador',
      editable: false,
      description: 'Nome do Operador',
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'date',
      headerName: 'Data de Início',
      description: 'Dia do atendimento',
      editable: false,
      type: 'dateTime',
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'endDate',
      headerName: 'Data de Término',
      description: 'Dia do atendimento',
      editable: false,
      type: 'dateTime',
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'roomDuration',
      headerName: 'Duração',
      description: 'Duração do atendimento',
      type: "string",
      editable: false,
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      sortComparator: (v1, v2, cellParams1, cellParams2, sortOrder) => {
        const milliseconds1 = cellParams1?.row?.roomDurationMilliseconds ?? 0;
        const milliseconds2 = cellParams2?.row?.roomDurationMilliseconds ?? 0;

        return sortOrder === 'asc'
          ? milliseconds1 - milliseconds2
          : milliseconds2 - milliseconds1;
      },
      renderCell: (params) => (
        <Tooltip title={params.row.roomDuration}>
          <Typography variant="subtitle2" align="right"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
            }}>
            {params.row.roomDuration}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'roomDurationMilliseconds',
      headerName: 'Duração',
      type: 'number',
      hide: true,
    },
    {
      field: 'history',
      headerName: 'Histórico',
      description: 'Histórico do atendimento',
      type: 'string',
      editable: false,
      flex: 1,
      headerClassName: 'table-sort-header compact',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleOpenConversation(params.row)}
          style={{ margin: '0 10px' }}
          className='reset-button'
        >
          <Typography variant='body2' fontSize={12} noWrap>
            Ver histórico
          </Typography>
        </Button>
      ),
    }
  ];

  const [sortModel, setSortModel] = useState([
    {
      field: 'roomDurationMilliseconds',
      sort: 'asc',
    },
  ]);

  const DateInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <TextField
      ref={ref}
      onClick={onClick}
      value={value}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      sx={{
        width: '140px',
        '& .MuiOutlinedInput-root': {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          '& fieldset': {
            borderColor: theme.palette.divider,
          },
          '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
          },
        },
        '& .MuiInputBase-input': {
          fontSize: '12px',
          padding: '8px 12px',
          cursor: 'pointer',
          color: theme.palette.text.primary,
        },
        '& .MuiInputBase-input::placeholder': {
          color: theme.palette.text.secondary,
          opacity: 1,
        },
      }}
      InputProps={{
        readOnly: true,
        endAdornment: (
          /*
            Ícone do MUI no lugar do emoji: ele herda `currentColor`, então
            acompanha o tema, e tem o mesmo desenho em qualquer sistema
            operacional -- emoji é fonte do sistema e muda de um para o outro.

            SEM tamanho: `AppThemeGlobalStyles` força
            `.MuiSvgIcon-root { font-size: 1.1rem !important }` no sistema
            todo. Qualquer `fontSize` que se escrevesse aqui seria código
            morto, e o ícone fica do tamanho de todos os outros.
          */
          <IconButton size="small" sx={{ padding: '4px', color: theme.palette.text.secondary }}>
            <CalendarTodayOutlined />
          </IconButton>
        ),
      }}
    />
  ));

  const handleOpenConversation = (conversation) => {
    setSelectedConversation(conversation);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const renderMessage = (message, i, conversation) => (
    <Grid item xs={12} key={i} sx={{ paddingLeft: '0 !important', marginTop: '16px', backgroundColor: 'transparent' }}>
      <Paper
        elevation={3}
        style={{
          padding: '10px',
          backgroundColor: message.type === 4 ? '#e0f7fa' : '#f0f0f0',
          borderRadius: '15px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        {message.type === 'image' || message.message.includes('.jpg') || message.message.includes('.png') || message.message.includes('.jpeg') ? (
          <Box className='avatar-container' sx={{ maxWidth: '100%', borderRadius: '10px', overflow: 'hidden', width: '20rem', position: 'relative' }}>
            <CardMedia
              component="img"
              image={chatAttachmentUrlFromMessage(message)}
              alt={message.message}
              sx={{ borderRadius: '10px', maxHeight: '200px', objectFit: 'cover', cursor: 'pointer', height: '5rem' }}
              onClick={() => handleClickOpen(chatAttachmentUrlFromMessage(message))}
            />
            <Grid className='avatar-overlay' sx={{ backgroundColor: 'transparent' }} onClick={() => handleClickOpen(chatAttachmentUrlFromMessage(message))}>

              <ZoomIn />
            </Grid>

            {/* Modal para expandir a imagem */}
            <Dialog open={open} onClose={handleClose} maxWidth="lg">
              <FilePreview
                selectedFile={selectedImage}
                setSelectedFile={setSelectedImage}
                isChat={false}
              />
            </Dialog>
          </Box>
        ) : (
          /*
            O texto da mensagem é HTML: o editor do operador e as mensagens
            automáticas gravam `<p>...</p>`. Esta era a única tela que o
            escapava, então as tags apareciam literais para o usuário.

            Sanitizado na renderização, como as demais telas de mensagem — o
            conteúdo vem do chat público e a API grava verbatim.
          */
          <Typography
            variant="body1"
            component="div"
            style={{ color: '#333' }}
            dangerouslySetInnerHTML={{ __html: sanitizeChatMessage(message.message) }}
          />
        )}
        <Typography variant="caption" style={{ color: '#888', display: 'block', marginTop: '5px' }}>
          {message.type === 4 || message.type === 3 ? 'Mensagem automática' : message.type === 1 ? user.name : conversation.clientName} • {format(new Date(message.created_at), 'HH:mm dd/MM/yyyy')}
        </Typography>
      </Paper>
    </Grid>
  );

  // A mensagem e HTML. Comparar a busca contra o HTML cru faz procurar por
  // "p" casar com toda mensagem que tenha <p>, e "img" com toda imagem --
  // resultado que o usuario nao pediu e nao entende. Compara-se o texto
  // visivel, que e o que ele esta lendo na tela.
  const textoVisivel = (html) => {
    const container = document.createElement('div');
    container.innerHTML = html || '';
    return (container.textContent || '').toLowerCase();
  };

  const filterMessages = (messages, filterType, searchValue) => {
    let filteredMessages = [];

    switch (filterType) {
      case 'client':
        filteredMessages = messages.filter(message => message.type === 0);
        break;
      case 'operator':
        filteredMessages = messages.filter(message => message.type === 1);
        break;
      case 'message':
      default:
        filteredMessages = messages.filter(message =>
          searchValue === "" || textoVisivel(message.message).includes(searchValue.toLowerCase())
        );
        break;
    }

    return filteredMessages;
  };


  const MessagesList = ({ messages, conversation }) => (
    <Grid container spacing={0} style={{ padding: '20px', backgroundColor: theme.palette.primary.main }}>
      <Select
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
      >
        <MenuItem value={"message"}>Todas mensagens</MenuItem>
        <MenuItem value={"client"}>Cliente: {conversation.clientName}</MenuItem>
        <MenuItem value={"operator"}>Operador: {user.name}</MenuItem>
      </Select>
      {filterMessages(messages, filterType, searchValue).length > 0 ?
        filterMessages(messages, filterType, searchValue).map((message, i) => renderMessage(message, i, conversation)) :
        <Grid container sx={{ backgroundColor: 'transparent', marginTop: '1rem' }}>
          <Grid item xs={12} sx={{ backgroundColor: 'transparent', textAlign: 'center' }}>
            Nenhuma mensagem encontrada
          </Grid>
        </Grid>
      }
    </Grid>
  );

  return (
    <Grid className='history-page' sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Grid container wrap='nowrap' sx={{ padding: '8px 16px', mb: 2 }}>
        <Grid item xs={12} container 
          spacing={2} 
          wrap='nowrap' 
          alignItems="center"
          justifyContent="flex-end"
          sx={{ 
            backgroundColor: 'transparent', 
            minHeight: '64px'
          }}>
          {/* Pesquisa de Cliente */}
          <Grid item sx={{ minWidth: '200px', flex: 1, backgroundColor: 'transparent' }}>
            <TextField
              size="small"
              placeholder="Pesquisar cliente..."
              value={clientSearchValue}
              onChange={(e) => setClientSearchValue(e.target.value)}
              fullWidth
              sx={{
                backgroundColor: theme.palette.background.paper,
                '& .MuiOutlinedInput-root': {
                  color: theme.palette.text.primary,
                  '& fieldset': {
                    borderColor: theme.palette.divider,
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: theme.palette.text.secondary,
                  opacity: 1,
                },
              }}
              InputProps={{
                endAdornment: (
                  <IconButton size="small" sx={{ padding: '4px', color: theme.palette.text.secondary }}>
                    <SearchOutlined />
                  </IconButton>
                ),
              }}
            />
          </Grid>
          
          {/* Botão de Filtros */}
          <Grid item sx={{ backgroundColor: 'transparent' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={temFiltroAtivo ? <FilterAltSharp /> : <FilterAltOffSharp />}
              onClick={handleOpenFilterPanel}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                px: 3
              }}
            >
              Configurar Filtros
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        {/*
          * Os totais do período (pontos 14 a 16). Ficam ACIMA da lista e
          * dentro da mesma área rolável: são a leitura de cima para baixo --
          * primeiro o resultado, depois os atendimentos que o compõem.
          *
          * Os números saem do servidor com os MESMOS filtros da lista. O
          * intervalo vai como `inicio:fim` porque é o que a página mantém em
          * `startDate`/`endDate` para todo período escolhido.
          */}
        <ResumoDoHistorico
          dateRange={`${dataLocal(startDate)}:${dataLocal(endDate)}`}
          userId={selectedUserIds}
          canal={canalFilter}
          linha={linhaFilter}
          search={clientSearchValue}
        />
        <TableInfo
          rows={rows}
          columns={columns}
          isBorder={true}
          fullHeight={true}
          autoHeight={false}
          color={theme.palette.background.default}
          sortModel={sortModel}
          onSortModelChange={setSortModel}
        />
      </Box>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <Grid container justifyContent="space-between" alignItems="center" sx={{ backgroundColor: 'transparent' }}>
          <DialogTitle>Histórico da Conversa</DialogTitle>
          <DialogActions>
            {/*
              O `onClick` estava no ÍCONE, não no botão -- e o MUI avisava
              exatamente isso no console. Não era só aviso: só o desenho do X
              fechava o diálogo, e a borda do botão em volta dele (que é a
              área que a pessoa mira) não fazia nada.
            */}
            <IconButton
              onClick={handleCloseDialog}
              aria-label="Fechar o histórico da conversa"
              sx={{ color: theme.palette.button.primary }}
            >
              <CloseSharp />
            </IconButton>
          </DialogActions>
          {selectedConversation && (
            <Autocomplete
              sx={{ padding: '0 24px' }}
              fullWidth
              disableClearable
              freeSolo
              options={selectedConversation.messages.map(messages => messages.message)}
              filterOptions={(options, state) => {
                return options.filter(option =>
                  option.toLowerCase().includes(state.inputValue.toLowerCase())
                );
              }}
              onInputChange={(event, newValue) => {
                setSearchValue(newValue);
              }}
              onChange={(event, newValue) => {
                // Implementar lógica para lidar com a mensagem selecionada, se necessário
              }}
              renderOption={() => <></>}
              PaperComponent={() => <></>}
              renderInput={(params) => (
                <TextField
                  variant='filled'
                  {...params}
                  label="Pesquisar mensagem"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        <IconButton sx={{ color: theme.palette.button.primary }}>
                          <SearchSharp />
                        </IconButton>
                      </>
                    ),
                  }}
                />
              )}
            />
          )}
        </Grid>
        <DialogContent>
          {selectedConversation && (
            <MessagesList messages={selectedConversation.messages} conversation={selectedConversation} />
          )}
        </DialogContent>
      </Dialog>

      {/* Slide Panel de Filtros */}
      <FilterSlidePanel
        open={filterPanelOpen}
        onClose={handleCloseFilterPanel}
        title="Filtros de Histórico"
        onApply={handleApplyFilters}
        onCancel={handleClearFilters}
        selectedFilter={temFiltroAtivo ? true : null}
        applyButtonText="Aplicar Filtros"
        cancelButtonText="Limpar Filtros"
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Filtro por Operador */}
          {permissions.includes('#history-users') && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Operador
              </Typography>
              {/*
                * MAIS DE UM operador, com marcação e os NOMES na caixa
                * fechada -- sem `renderValue` o MUI escreve os ids.
                *
                * Desmarcar o ÚLTIMO não é permitido: lista vazia a api lê
                * como "o meu histórico", e a tela mostraria o de alguém sem
                * dizer de quem. Quem quiser voltar ao próprio histórico
                * marca "Meu histórico" e desmarca o resto.
                */}
              <Select
                multiple
                value={selectedUserIds.map(String)}
                onChange={(e) => setSelectedUserIds(
                  selecaoDeOperadores(e.target.value, selectedUserIds)
                )}
                renderValue={() => operadoresEscolhidos()}
                fullWidth
                size="small"
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.divider,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                  '& .MuiSelect-select': {
                    color: theme.palette.text.primary,
                  },
                }}
              >
                <MenuItem value={String(user.id)}>
                  <Checkbox size="small" checked={selectedUserIds.map(String).includes(String(user.id))} />
                  <ListItemText primary="Meu histórico" />
                </MenuItem>
                {props.users && (props.users.map((currentUser) => (
                  currentUser.id !== user.id
                    ?
                    <MenuItem key={currentUser.id} value={String(currentUser.id)}>
                      <Checkbox size="small" checked={selectedUserIds.map(String).includes(String(currentUser.id))} />
                      <ListItemText primary={currentUser.name} />
                    </MenuItem>
                    : null
                )))}
              </Select>
            </Box>
          )}

          {/* Filtro por Período */}
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              Período
            </Typography>
            <Select
              value={periodType}
              onChange={(e) => handlePeriodChange(e.target.value)}
              fullWidth
              size="small"
              sx={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.divider,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiSelect-select': {
                  color: theme.palette.text.primary,
                },
              }}
            >
              <MenuItem value="today">Hoje</MenuItem>
              <MenuItem value="week">Última semana</MenuItem>
              <MenuItem value="month">Último mês</MenuItem>
              <MenuItem value="custom">Personalizado</MenuItem>
            </Select>
          </Box>

          {/* Filtro por Data Personalizada */}
          {periodType === 'custom' && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Datas Personalizadas
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => {
                    setPeriodType('custom');
                    handleDateChange(date, endDate, null);
                  }}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={endDate}
                  dateFormat="dd/MM/yyyy"
                  customInput={<DateInput placeholder="Data início" />}
                  locale={ptBR}
                />
                <DatePicker
                  selected={endDate}
                  onChange={(date) => {
                    setPeriodType('custom');
                    handleDateChange(startDate, date, null);
                  }}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  dateFormat="dd/MM/yyyy"
                  customInput={<DateInput placeholder="Data fim" />}
                  locale={ptBR}
                />
              </Box>
            </Box>
          )}

          {/* Filtro por Cliente */}
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              Pesquisar Cliente
            </Typography>
            <TextField
              size="small"
              placeholder="Pesquisar cliente..."
              value={clientSearchValue}
              onChange={(e) => setClientSearchValue(e.target.value)}
              fullWidth
              sx={{
                backgroundColor: theme.palette.background.paper,
                '& .MuiOutlinedInput-root': {
                  color: theme.palette.text.primary,
                  '& fieldset': {
                    borderColor: theme.palette.divider,
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: theme.palette.text.secondary,
                  opacity: 1,
                },
              }}
            />
          </Box>

          {/*
            * Filtro por Avaliação, com MÚLTIPLA seleção (pedido da Gisele).
            *
            * Nada escolhido é "todas" -- é o que o valor `all` do seletor
            * único significava, e por isso ele saiu em vez de virar uma opção
            * marcável no meio das notas.
            */}
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              Avaliação
            </Typography>
            <Select
              size="small"
              fullWidth
              multiple
              displayEmpty
              value={evaluationFilters}
              onChange={(e) => setEvaluationFilters(
                (Array.isArray(e.target.value) ? e.target.value : []).map(Number)
              )}
              inputProps={{ 'aria-label': 'Avaliação' }}
              renderValue={(escolhidas) => (escolhidas.length === 0
                ? 'Todas'
                : rotulosDasAvaliacoes(escolhidas))}
              sx={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
              }}
            >
              {[3, 2, 1].map((nota) => (
                <MenuItem key={nota} value={nota}>
                  <Checkbox
                    checked={evaluationFilters.indexOf(nota) !== -1}
                    size="small"
                    sx={{ mr: 1, p: 0 }}
                  />
                  <Rating value={nota} max={3} size="small" readOnly />
                </MenuItem>
              ))}
              <MenuItem value={0}>
                <Checkbox
                  checked={evaluationFilters.indexOf(0) !== -1}
                  size="small"
                  sx={{ mr: 1, p: 0 }}
                />
                Sem avaliação
              </MenuItem>
            </Select>
          </Box>

          {/*
            * Filtro por Departamento, também múltiplo.
            *
            * Só aparece com MAIS DE UM departamento no período carregado,
            * pelo mesmo motivo do seletor de produto: com um só ele não
            * recortaria nada. O rótulo vem de `service_group.description`,
            * que a api passou a mandar junto com a sala.
            */}
          {departamentosDisponiveis.length > 1 && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Departamento
              </Typography>
              <Select
                size="small"
                fullWidth
                multiple
                displayEmpty
                value={departamentoFilters}
                onChange={(e) => setDepartamentoFilters(
                  (Array.isArray(e.target.value) ? e.target.value : []).map(Number)
                )}
                inputProps={{ 'aria-label': 'Departamento' }}
                renderValue={(escolhidos) => (escolhidos.length === 0
                  ? 'Todos'
                  : rotulosDosDepartamentos(escolhidos, departamentosDisponiveis))}
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
                }}
              >
                {departamentosDisponiveis.map((departamento) => (
                  <MenuItem key={departamento.id} value={departamento.id}>
                    <Checkbox
                      checked={departamentoFilters.indexOf(departamento.id) !== -1}
                      size="small"
                      sx={{ mr: 1, p: 0 }}
                    />
                    {departamento.descricao}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}

          {/*
            * Canal e produto (ponto 13 da Gisele, 27/10/2026).
            *
            * Dois seletores, e não um de quatro opções: canal é por onde a
            * conversa chegou e Sysfar/MAX é a linha de produto do cliente.
            * Ver `utils/filtrosDoHistorico`.
            */}
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              Canal
            </Typography>
            <Select
              size="small"
              fullWidth
              value={canalFilter}
              onChange={(e) => setCanalFilter(e.target.value)}
              inputProps={{ 'aria-label': 'Canal' }}
              sx={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
              }}
            >
              {CANAIS.map((canal) => (
                <MenuItem key={canal.value} value={canal.value}>{canal.label}</MenuItem>
              ))}
            </Select>
          </Box>

          {/*
            * O seletor de produto só aparece quando há MAIS DE UMA linha no
            * período carregado: com uma só ele não recortaria nada, e um
            * controle que não faz nada é pior que nenhum.
            */}
          {linhasDisponiveis.length > 1 && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Produto
              </Typography>
              <Select
                size="small"
                fullWidth
                value={linhaFilter}
                onChange={(e) => setLinhaFilter(e.target.value)}
                inputProps={{ 'aria-label': 'Produto' }}
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
                }}
              >
                <MenuItem value={LINHA_TODAS}>Todos os produtos</MenuItem>
                {linhasDisponiveis.map((linha) => (
                  <MenuItem key={linha} value={linha}>{linha}</MenuItem>
                ))}
              </Select>
            </Box>
          )}

          {/* Informações dos filtros ativos */}
          {temFiltroAtivo && (
            <Box sx={{ 
              p: 2, 
              backgroundColor: theme.palette.primary.light,
              borderRadius: 1,
              color: theme.palette.primary.contrastText
            }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                Filtros Ativos:
              </Typography>
              {!soMeuHistorico && (
                <Typography variant="body2">
                  • {selectedUserIds.length > 1 ? 'Operadores' : 'Operador'}: {operadoresEscolhidos()}
                </Typography>
              )}
              {periodType !== 'custom' && (
                <Typography variant="body2">
                  • Período: {periodType === 'today' ? 'Hoje' : periodType === 'week' ? 'Última semana' : 'Último mês'}
                </Typography>
              )}
              {clientSearchValue !== '' && (
                <Typography variant="body2">
                  • Cliente: "{clientSearchValue}"
                </Typography>
              )}
              {evaluationFilters.length > 0 && (
                <Typography variant="body2">
                  • {evaluationFilters.length > 1 ? 'Avaliações' : 'Avaliação'}: {rotulosDasAvaliacoes(evaluationFilters)}
                </Typography>
              )}
              {departamentoFilters.length > 0 && (
                <Typography variant="body2">
                  • {departamentoFilters.length > 1 ? 'Departamentos' : 'Departamento'}: {rotulosDosDepartamentos(departamentoFilters, departamentosDisponiveis)}
                </Typography>
              )}
              {canalFilter !== CANAL_TODOS && (
                <Typography variant="body2">
                  • Canal: {(CANAIS.filter((c) => c.value === canalFilter)[0] || {}).label || canalFilter}
                </Typography>
              )}
              {linhaFilter !== LINHA_TODAS && (
                <Typography variant="body2">
                  • Produto: {linhaFilter}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </FilterSlidePanel>
    </Grid>
  )
}


const mapStateToProps = state => {
  const { rooms, user } = state;
  const { historyRooms } = rooms;
  const { users, permissions } = user
  return { historyRooms, users, permissions };
};

const mapDispatchToProps = dispatch => ({
  getHistoryRooms: (date, userId) => dispatch(getHistoryRooms(date, userId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HistoryPage);